module.exports = __webpack_public_path__ + "img/eyes_male_extra_round_mask.feab3c5c.png";